var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageContent',{attrs:{"id":"faqs"}},[_c('template',{slot:"heading-title"},[_vm._v("Frequently Asked Questions")]),_vm._v(" "),_c('div',{staticClass:"container",attrs:{"slot":"content"},slot:"content"},[_c('FaqContent')],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }